import * as React from "react";

interface Props {
  loadingText: string;
}

const Spinner = (props: Props) => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div
        className="overlay"
        id="popupOverlay"
        style={{ display: "block" }}
      ></div>
      <div className="text-center" style={{ marginRight: "70px" }}>
        <div
          className="spinner-border"
          role="status"
          style={{
            position: "fixed",
            top: "200px",
            zIndex: 10001,
            color: "#ffffff",
            width: "5rem",
            height: "5rem",
            borderWidth: "0.5em",
          }}
        >
          <span className="sr-only">{props.loadingText}</span>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
